import React from 'react'
import { RichTextWrapper } from '../../../styles/global'
import { internalLinkHandler } from '../../../utils/link.utils'
import { renderRichText } from '../../../utils/richTextHandler.utils'
import formatInlineCode from '../../../utils/shortTextFormatting'
import Button from '../button'
import Typography from '../typography'

export const Content = ({ content }: any) => {
  const cta1Href = content.cta[0]?.internalLink
    ? internalLinkHandler(content.cta[0].internalLink)
    : content.cta[0]?.externalUrl || ''

  const cta2Href = content.cta[1]?.internalLink
    ? internalLinkHandler(content.cta[1].internalLink)
    : content.cta[1]?.externalUrl || ''

  const ctas = (
    <div className="ContentBlock__Buttons">
      <Button
        icon={true}
        href={cta1Href}
        text={content.cta[0]?.text || ''}
        type={content.cta1Style}
        size="small"
        theme={content.contentBlockTheme === 'Dark' ? 'dark' : 'light'}
      />

      {content.cta[1] && (
        <Button
          icon={true}
          href={cta2Href}
          text={content.cta[1]?.text || ''}
          type={content.cta2Style}
          size="small"
          theme={content.contentBlockTheme === 'Dark' ? 'dark' : 'light'}
        />
      )}
    </div>
  )

  const finePrint = content.finePrintWithHyperlinks && (
    <div className="ContentBlock__Fineprint-Container">
      <RichTextWrapper $type="finePrint" className="ContentBlock__Fineprint">
        {renderRichText(content.finePrintWithHyperlinks)}
      </RichTextWrapper>
    </div>
  )

  return (
    <div className="ContentBlock__Inner-Container">
      {content.eyebrow && (
        <Typography type="labelAlt" className="ContentBlock__Eyebrow">
          {content.eyebrow}
        </Typography>
      )}

      {content.headline && (
        <Typography type="header2" className="ContentBlock__Headline">
          {formatInlineCode(content.headline)}
        </Typography>
      )}

      {content.body && (
        <RichTextWrapper $type="leadXS" className="ContentBlock__Body">
          {renderRichText(content.body)}
        </RichTextWrapper>
      )}

      {content.cta && content.cta[0] && ctas}
      {content.finePrintWithHyperlinks && finePrint}
    </div>
  )
}
